import {
  Create,
  CreateButton,
  Edit,
  EditButton,
  List,
  useDrawerForm,
  useTable,
} from '@refinedev/antd';
import { Drawer, Form, Input, Space, Table } from 'antd';
import { ISitter } from '../../interfaces/sitter';
import { ImageUpload } from '../../components/form-item/ImageUpload';

export const SittersList = () => {
  const { tableProps } = useTable<ISitter>({
    resource: 'sitters',
    sorters: {
      initial: [{ field: 'createdAt', order: 'desc' }],
    },
    meta: {
      fields: [
        'id',
        'email',
        'name',
        'university',
        'createdAt',
        'updatedAt',
        {
          avatar: ['id', 'url'],
        },
      ],
    },
  });
  // create
  const {
    formProps: createFormProps,
    drawerProps: createDrawerProps,
    show: createDrawerShow,
    saveButtonProps: createSaveButtonProps,
    deleteButtonProps: createDeleteButtonProps,
    id,
    formLoading: editFormLoading,
  } = useDrawerForm<ISitter>({
    action: 'create',
    syncWithLocation: true,
    meta: {
      fields: [{ sitter: ['id'] }],
    },
  });
  // edit
  const {
    formProps: editFormProps,
    drawerProps: editDrawerProps,
    show: editDrawerShow,
    saveButtonProps: editSaveButtonProps,
  } = useDrawerForm<ISitter>({
    action: 'edit',
    syncWithLocation: true,
    meta: {
      fields: [
        'id',
        'name',
        'university',
        'email',
        {
          avatar: ['id', 'url'],
        },
      ],
    },
    mutationMeta: {
      fields: [{ sitter: ['id'] }],
    },
  });

  return (
    <>
      <List
        resource="sitters"
        headerProps={{ title: 'シッター' }}
        headerButtons={
          <Space>
            <CreateButton onClick={() => createDrawerShow()} />
          </Space>
        }
      >
        <Table
          {...tableProps}
          rowKey="id"
          pagination={{
            ...tableProps.pagination,
            showSizeChanger: true,
            showTotal: (total) => `全${total}件`,
          }}
        >
          <Table.Column<ISitter> dataIndex="email" title="メールアドレス" />
          <Table.Column<ISitter> dataIndex="name" title="表示名" />
          <Table.Column<ISitter>
            dataIndex="avatar"
            title="画像"
            render={(value, record) => <img src={value.url} alt="avatar" width={100} />}
          />
          <Table.Column<ISitter> dataIndex="university" title="大学" />
          <Table.Column<ISitter>
            dataIndex="actions"
            render={(_, record) => <EditButton onClick={() => editDrawerShow(record.id)} />}
          />
        </Table>
      </List>
      <Drawer {...createDrawerProps}>
        <Create saveButtonProps={createSaveButtonProps} goBack={false}>
          <Form {...createFormProps} layout="vertical">
            <Form.Item name="email" label="メールアドレス">
              <Input />
            </Form.Item>
            <Form.Item name="name" label="表示名">
              <Input />
            </Form.Item>
            <Form.Item name="university" label="大学">
              <Input />
            </Form.Item>
            <Form.Item name="avatar" label="画像">
              <ImageUpload />
            </Form.Item>
          </Form>
        </Create>
      </Drawer>
      <Drawer {...editDrawerProps}>
        <Edit
          recordItemId={id}
          saveButtonProps={editSaveButtonProps}
          isLoading={editFormLoading}
          goBack={false}
          breadcrumb={false}
          headerButtons={[]}
        >
          <Form {...editFormProps} layout="vertical">
            <Form.Item name="email" label="メールアドレス">
              <Input />
            </Form.Item>
            <Form.Item name="name" label="表示名">
              <Input />
            </Form.Item>
            <Form.Item name="university" label="大学">
              <Input />
            </Form.Item>
            <Form.Item name="avatar" label="画像">
              <ImageUpload />
            </Form.Item>
          </Form>
        </Edit>
      </Drawer>
    </>
  );
};
